export function egtoOverlay($rootScope) {
    var directive = {
        restrict: 'E',
        scope: {},
        templateUrl: 'app/shared/overlay.directive.html',
        link: link
    };
    return directive;

    function link(scope, element) {
        var changeStartOff = $rootScope.$on('$stateChangeStart', showOverlay);
        var changeSuccessOff = $rootScope.$on('$stateChangeSuccess', hideOverlay);
        var changeErrorOff = $rootScope.$on('$stateChangeError', hideOverlay);

        scope.$on('$destroy', function () {
            changeStartOff();
            changeSuccessOff();
            changeErrorOff();
        });

        function showOverlay() {
            element.addClass('visible');
        }

        function hideOverlay() {
            element.removeClass('visible');
        }
    }
}

egtoOverlay.$inject = ['$rootScope'];